<template>
  <div class="form">
    <span class="title">{{ $t("views.form.title") }}</span>
    <span class="sec-description" v-html="$t('views.form.description')"></span><br>
    <span v-html="$t('views.form.min_date')"></span>
    <v-container grid-list-xl>
      <v-layout wrap>

        <div class="form-section">{{ $t("views.form.info_title") }}</div>

        <v-flex md6 align-center>
          <v-textarea v-model="form.site" auto-grow rows="1" :label="$t('views.form.site')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.type" auto-grow rows="1" :label="$t('views.form.type')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.property" auto-grow rows="1" :label="$t('views.form.property')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.license" auto-grow rows="1" :label="$t('views.form.license')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.franchisee_name" auto-grow rows="1" :label="$t('views.form.franchisee_name')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.cfs" auto-grow rows="1" :label="$t('views.form.cfs')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.rrhh" auto-grow rows="1" :label="$t('views.form.rrhh')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.eotf" auto-grow rows="1" :label="$t('views.form.eotf')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.opening_date" auto-grow rows="1" :label="$t('views.form.opening_date')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.address" auto-grow rows="1" :label="$t('views.form.address')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.phone" auto-grow rows="1" :label="$t('general.phone')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.mail" auto-grow rows="1" :label="$t('views.form.mail')"></v-textarea>
        </v-flex>

        <div class="form-section">Datos técnicos</div>

        <v-flex md6 align-center>
          <v-textarea v-model="form.kiosk" auto-grow rows="1" :label="$t('views.form.kiosk')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.mcauto" auto-grow rows="1" :label="$t('views.form.mcauto')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.mccafe" auto-grow rows="1" :label="$t('views.form.mccafe')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.table" auto-grow rows="1" :label="$t('views.form.table')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.signature" auto-grow rows="1" :label="$t('views.form.signature')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.delivery" auto-grow rows="1" :label="$t('views.form.delivery')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.games" auto-grow rows="1" :label="$t('views.form.games')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.marketing" auto-grow rows="1" :label="$t('views.form.marketing')"></v-textarea>
        </v-flex>
        
        <v-flex md6 align-center>
          <v-textarea v-model="form.contact" auto-grow rows="1" :label="$t('views.form.contact')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.opening_speech" auto-grow rows="1" :label="$t('views.form.opening_speech')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.authorities" auto-grow rows="1" :label="$t('views.form.authorities')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.other_mentions" auto-grow rows="1" :label="$t('views.form.other_mentions')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.employee_speech" auto-grow rows="1" :label="$t('views.form.employee_speech')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.workplaces" auto-grow rows="1" :label="$t('views.form.workplaces')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.meters" auto-grow rows="1" :label="$t('views.form.meters')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.city" auto-grow rows="1" :label="$t('views.form.city')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.province" auto-grow rows="1" :label="$t('views.form.province')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.autonomous_community" auto-grow rows="1" :label="$t('views.form.autonomous_community')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
          <v-textarea v-model="form.other" auto-grow rows="1" :label="$t('views.form.other')"></v-textarea>
        </v-flex>

        <v-flex md6 align-center>
        </v-flex>

        <div class="button submit" @click="sendMail()">{{ $t("general.send") }}</div>

      </v-layout>
    </v-container>

  </div>
</template>

<script>
import i18n from "@/i18n";
import {Api} from '@/core/api.js';
const api = new Api();

export default {
  name: 'ComunicationForm',
 
  data () {
    return {
      form: {
        site: "",
        type: "",
        property: "",
        license: "",
        franchisee_name: "",
        cfs: "",
        rrhh: "",
        eotf: "",
        opening_date: "",
        address: "",
        phone: "",
        mail: "",
        kiosk: "",
        mcauto: "",
        mccafe: "",
        table: "",
        signature: "",
        delivery: "",
        games: "",
        marketing: "",
        contact: "",
        opening_speech: "",
        authorities: "",
        other_mentions: "",
        employee_speech: "",
        workplaces: "",
        meters: "",
        city: "",
        province: "",
        autonomous_community: "",
        other: ""
      }
    }
  },
  computed: {
    selectedLocation (){
      return this.$store.getters['locations/getSelectedLocation'];
    },
  },
  methods: {
    sendMail() {
      if(this.topic!="") {
        this.$overlay.loading();
        var self = this;
        api.post( 'restaurant/opening', { data: JSON.stringify(this.form), restaurant_name: this.selectedLocation.name, restaurant_site: this.selectedLocation.site } ).then( function( response ){
          self.$overlay.hide();
          self.$popup.alert(
          self.$t("views.form.success"),
          function(){
          });
        });
      }
    }
  },
  watch: {
  },
  created() {
    this.$store.commit('setTitle', this.$t("views.form.name"));
    this.$store.commit('setMenuVisible', false);
  },
  beforeRouteLeave (to, from, next) {
      next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .form {

    .form-section {
      display: block;
      width: 100%;
      border-bottom: 2px solid #ccc;
      text-align: left;
      text-transform: uppercase;
      margin-top: 30px;
      color: #aaa;
      font-size: 17px;
      background-color: #f2f2f2;
      padding: 10px; 
    }

    .title {
      display: block;
      margin-top: 30px;
      margin-bottom: 10px;
    }

    .submit {
      padding: 10px 50px;
      background-color: var(--main_color);
      margin: 30px auto;
      font-size: 16px;
      cursor: pointer;
    }
  }
  


</style>